/**
 * The filter row above a list.
 *
 * Every list screen had grown its own `.filters` grid — two columns here, four
 * there, `minmax(220px, 2fr)` in three places — and the grids disagreed with
 * their own contents. Volunteers put three filters into a two-column track, so
 * "Available" wrapped onto a second row and then stretched to twice the width
 * of the select above it. A stretched track also means a Status select sized
 * for "All statuses" rendered 400px wide, which is the other half of why the
 * filters read as the heaviest thing on the page rather than the lightest.
 *
 * A row, not a grid. Controls take the width their content needs and wrap only
 * when the card genuinely runs out of room, so the filters occupy one line on
 * any ordinary screen and the table below stays the thing you look at.
 */

import type { ReactNode } from 'react';
import styles from './FilterBar.module.css';

export interface FilterBarProps {
  /** `TextInput` / `SelectInput` fields, in the order staff reach for them. */
  children: ReactNode;
  /** Describes the group for screen readers, e.g. "Filter volunteers". */
  label?: string;
}

export function FilterBar({ children, label = 'Filters' }: FilterBarProps) {
  return (
    <div className={styles.bar} role="group" aria-label={label}>
      {children}
    </div>
  );
}
